import { useEffect, useState } from 'react';

import { axiosInstance } from '@/api/client';

/**
 * Slike se ne serviraju s direktnog S3 URL-a nego kroz autenticirani backend
 * endpoint (Authorization header), pa običan <img src> ne radi — dohvati bajtove
 * kao blob i napravi object URL koji <img> može koristiti.
 */
export const useAuthenticatedImage = (url: string | null | undefined): string | null => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!url) {
      setObjectUrl(null);
      return;
    }

    let cancelled = false;
    let createdUrl: string | null = null;

    axiosInstance
      .get(url, { responseType: 'blob' })
      .then((response) => {
        if (cancelled) return;
        createdUrl = URL.createObjectURL(response.data);
        setObjectUrl(createdUrl);
      })
      .catch(() => {
        if (!cancelled) setObjectUrl(null);
      });

    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [url]);

  return objectUrl;
};
